import React, { useState, useCallback } from 'react';
import MyToggle from '../basic/MyToggle';
import './AccountCardsFrame.css';

const AccountCardsFrame = ({ children }) => {
  const [isCompactView, setIsCompactView] = useState(true);

  const handleToggleView = useCallback((event) => {
    const newValue = event.target.checked;
    setIsCompactView(newValue);
    console.log('View toggled:', newValue ? 'Compact' : 'Advanced');
  }, []);

  // Clone children and pass isCompactView prop
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { isCompactView });
    }
    return child;
  });

  return (
    <div className="account-cards-frame">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h2>Your Accounts</h2>
        <MyToggle
          checked={isCompactView}
          onChange={handleToggleView}
          label={isCompactView ? "Compact" : "Advanced"}
        />
      </div>
      <div className="account-cards-container">
        {childrenWithProps}
      </div>
    </div>
  );
};

export default AccountCardsFrame;